import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Vas from '../Vas';
import '../css/SuccessText.css';

class SuccessText  extends Component {

    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
      
        return (<div className="LoginContainer">
          <div className={"form"}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["OrderSuccessfully"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width:'102px' }}>{Vas.Resources.Labels["LinkLogin"]}</td>
                  <td><Link
                    className={"link"}
                    to={"/login"}> {Vas.Resources.Menus["Login"]}</Link></td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>  );
    }
}
export default SuccessText;
